"use strict";

function showPinModal() {
	var pin;

	if ($("#pinModalContent").length) {
		// There is already a pin modal launched
		return;
	}

	async.parallel([
		function (next) {
			$.ajax({
				url: "/api/pin",
				type: "POST",
				contentType: "application/json",
				success: function (data) {
					pin = data.pin;
					next();
				}
			});
		}
	], function (error) {
		if (error) {
			console.error(error);
		} else {
			var $message = $("<div id='pinModalContent'><p style='font-size: 50px; text-align: center;'>" + pin + "</p></div>");
			if (window.pinModal.paragraph) {
				var paragraphHtml = removeUnsupportedTagsFromHtml(["script"], window.pinModal.paragraph);
				var $paragraph = $("<div style='margin-bottom: 10px;'>" + paragraphHtml + "</div>");
				$message.append($paragraph);
			}

			var options = {
				onshown: function (dialogRef) {
					dialogRef.$modalFooter.find("button").first().focus();
				},
				closable: true,
				message: $message
			};
			if (window.pinModal.title) {
				options.title = window.pinModal.title;
			}
			BootstrapDialog.alert(options);
		}
	});
}

function removeUnsupportedTagsFromHtml(arrayOfTagsToStrip, html) {
	var temporaryDiv = document.createElement("div");
	temporaryDiv.innerHTML = html;

	arrayOfTagsToStrip = arrayOfTagsToStrip || [];

	arrayOfTagsToStrip.forEach(tag => {
		var tagsToStrip = temporaryDiv.getElementsByTagName(tag);
		var numberOfFoundTags = tagsToStrip.length;

		while (numberOfFoundTags > 0) {
			var foundTag = tagsToStrip[numberOfFoundTags - 1];
			foundTag.parentNode.removeChild(foundTag);

			numberOfFoundTags = numberOfFoundTags - 1;
		}
	});

	return temporaryDiv.innerHTML;
}

window.showPinModal = _.debounce(showPinModal, 500, { leading: true });

$("body").keydown(function (event) {
	if (event.key === "h" && event.ctrlKey && event.altKey) {
		showPinModal();
	}
});
